import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const PuestoPM = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/descripcion-puesto-pm.pdf`;
  /*const pdfUrl = "/pdf/descripcion-puesto-pm.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Descripción del Puesto: PM</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Descripción del Puesto: PM" />
      </Container>
    </>
  );
};

 export default PuestoPM;
